module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_construction_sp-37fd45689b84febc8ad93eb319d28caa.svg";